import { CombinedGraphQLErrors, isErrorLike } from "@apollo/client/errors";
import { codeOf, type GraphQLErrorLike } from "./describeGraphQLError";

const AUTH_LINK_MESSAGE_HINTS = ["requireAuthentication"];
const USER_QUERY_MESSAGE_HINTS = ["requireAuthentication", "invalid", "Unauthorized", "expired"];

function isAuthenticationFailure(error: GraphQLErrorLike, messageHints: readonly string[]): boolean {
  const code = codeOf(error);
  if (code === "UNAUTHENTICATED") return true;
  if (code === "FORBIDDEN") return false;
  return messageHints.some((hint) => error.message?.includes(hint));
}

export function isAuthLinkAuthenticationError(error: GraphQLErrorLike): boolean {
  return isAuthenticationFailure(error, AUTH_LINK_MESSAGE_HINTS);
}

export function isUserQueryAuthenticationError(error: unknown): boolean {
  if (CombinedGraphQLErrors.is(error)) {
    return error.errors.some((graphQLError) => isAuthenticationFailure(graphQLError, USER_QUERY_MESSAGE_HINTS));
  }
  return isErrorLike(error) && isAuthenticationFailure(error, USER_QUERY_MESSAGE_HINTS);
}
